<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    :width="width"
    :height="height"
    viewBox="0 0 16 16"
  >
    <g fill="none" fill-rule="evenodd">
      <g :fill="color">
        <g>
          <g>
            <path
              d="M13.5 0C14.88 0 16 1.12 16 2.5S14.88 5 13.5 5c-1.21 0-2.218-.859-2.45-2H5c-1.105 0-2 .895-2 2 0 1.054.816 1.918 1.85 1.995L5 7h6c1.657 0 3 1.343 3 3 0 1.598-1.249 2.904-2.824 2.995L11 13H4.95c-.232 1.141-1.24 2-2.45 2C1.12 15 0 13.88 0 12.5S1.12 10 2.5 10c1.21 0 2.219.86 2.45 2H11c1.105 0 2-.895 2-2 0-1.054-.816-1.918-1.85-1.995L11 8H5C3.343 8 2 6.657 2 5c0-1.598 1.249-2.904 2.824-2.995L5 2h6.05c.231-1.14 1.24-2 2.45-2zm-11 11c-.828 0-1.5.672-1.5 1.5S1.672 14 2.5 14 4 13.328 4 12.5 3.328 11 2.5 11zm11-10c-.828 0-1.5.672-1.5 1.5S12.672 4 13.5 4 15 3.328 15 2.5 14.328 1 13.5 1z"
              transform="translate(-24 -108) translate(0 92) translate(24 16)"
            />
          </g>
        </g>
      </g>
    </g>
  </svg>
</template>

<script>
import VueTypes from 'vue-types';
export default {
  name: 'PipelineIcon',
  props: {
    height: VueTypes.string.def('16'),
    width: VueTypes.string.def('16'),
    color: VueTypes.string.def('#6783B2')
  }
};
</script>

<style lang="scss"></style>
